import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	searchAcrossProducts: {
		id: 'search_dialog_search_across_products',
		defaultMessage: 'Search all apps',
		description: 'Label for link to redirect users to search page',
	},
	more: {
		id: 'search_dialog_search_across_products.more',
		defaultMessage: 'more',
		description: 'Label to signify that a user can search for more connected apps',
	},
});
